import React from 'react'
import { Row, Col, Typography, Avatar } from 'antd';
import "./achivement.css"
import client from '../images/client.png'
import project from '../images/project.png'
import award from '../images/awrdh.png'
import beliver from '../images/belivh.png'

const { Title, Text } = Typography;

function Achivements() {
    return (
        <div className="achivement-main-iamge">
            <div className="achivement-container" id="achivement">
                <div className="achive-heading-container">
                    <Text className="paragraph">
                        <p className="achive">
                            Our Achivements
                </p>
                    </Text>
                    <Title className="sectionHeading-achive">Facts & Figures</Title>

                </div>
                <div className="achi-main-cn">
                <Row justify="center" gutter={{ xs: 8, sm: 16, md: 24, lg: 32, xl: 16 }} >
                    <Col className="achive-col" xs={24} sm={13} md={9} lg={9} xl={6}>
                        <div className="achive-image">
                            <Avatar size={110} src={client} />
                        </div>
                        <div className="achive-nmbers">
                            <span>CLIENTS</span>
                            <p>520</p>
                        </div>
                    </Col>
                    <Col className="achive-col" xs={24} sm={13} md={9} lg={9} xl={6}>
                        <div className="achive-image">
                            <Avatar size={110} src={project} />
                        </div>
                        <div className="achive-nmbers">
                            <span>PROJECTS</span>
                            <p>350</p>
                        </div>
                    </Col>
                    <Col className="achive-col" xs={24} sm={13} md={9} lg={9} xl={6}>
                        <div className="achive-image">
                            <Avatar size={110} src={award} />
                        </div>
                        <div className="achive-nmbers">
                            <span>AWARDS</span>
                            <p>180</p>
                        </div>
                    </Col>
                    <Col className="achive-col" xs={24} sm={13} md={9} lg={9} xl={6}>
                        <div className="achive-image">
                            <Avatar size={110} src={beliver} />
                        </div>
                        <div className="achive-nmbers">
                            <span>STUDENTS</span>
                            <p>30k</p>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
        </div>

    )
}

export default Achivements